import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import { icon } from './ui';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import SiteSidebar from './SiteSidebar';
export default class RankingPage extends Page {
  loading = true;
  error = false;
  data = {
    levels: [],
    reputation: [],
    jobs: []
  };
  oncreate() {
    window.scrollTo(0, 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  async load() {
    const statusUrl = String(app.forum.attribute('novatruckServerStatusUrl') || 'https://api.novatruck-rp.pl/v1/server/status');
    const apiBase = statusUrl.replace(/\/server\/status\/?$/, '');
    try {
      const response = await fetch(`${apiBase}/rankings/overview?limit=10`, {
        headers: {
          Accept: 'application/json'
        }
      });
      if (!response.ok) throw new Error(String(response.status));
      this.data = await response.json();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  view() {
    return m("div", {
      className: "NtRankingPage"
    }, m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("main", null, m("header", {
      className: "NtPageHeading"
    }, m("small", null, "NOVA LEADERBOARDS"), m("h1", null, "Ranking graczy"), m("p", null, "Najlepsi kierowcy i najbardziej do\u015Bwiadczeni mieszka\u0144cy NovaTruck & RP.")), this.loading ? m("div", {
      className: "NtPageLoading"
    }, m(LoadingIndicator, null)) : this.error ? m("div", {
      className: "NtPageError"
    }, "Nie uda\u0142o si\u0119 pobra\u0107 rankingu. Spr\xF3buj ponownie za chwil\u0119.") : m("div", {
      className: "NtRankingGrid"
    }, this.table('Poziom postaci', 'fas fa-trophy', this.data.levels, 'LVL'), this.table('Reputacja', 'fas fa-star', this.data.reputation, 'REP'), this.table('Kariera zawodowa', 'fas fa-briefcase', this.data.jobs, 'REP', true)))));
  }
  table(title, iconName, rows, suffix, jobs) {
    if (jobs === void 0) {
      jobs = false;
    }
    return m("section", {
      className: "NtRankingCard"
    }, m("header", null, icon(iconName), m("h2", null, title)), m("ol", null, (rows || []).map(row => m("li", null, m("b", {
      className: `NtRank NtRank--${row.rank}`
    }, row.rank), m("span", null, m("strong", null, row.character_name), m("small", null, jobs ? row.job_name : `@${row.username}`)), m("em", null, row.value, " ", suffix)))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/RankingPage', RankingPage);